import { FC } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const ArrowContainerStyled = styled.div`
	position: absolute;
	bottom: 16px;
	z-index: 100;
	display: flex;
	justify-content: center;
	align-items: center;

	border-radius: 50%;
	filter: drop-shadow(0px 3px 8px rgba(93, 95, 97, 0.1));
	background-color: #fff;
	cursor: pointer;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		left: 41%;
		width: 36px;
		height: 36px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		left: 41%;
		width: 36px;
		height: 36px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		left: 42%;
		width: 42px;
		height: 42px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		left: 43.75%;
		width: 44px;
		height: 44px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		left: 43.75%;
		width: 44px;
		height: 44px;
	}
`;

interface ArrowProps {
	onClick?: () => void;
}

export const ArrowLeft: FC<ArrowProps> = ({ onClick }) => (
	<ArrowContainerStyled onClick={onClick}>
		<ArrowLeftOutlined />
	</ArrowContainerStyled>
);
